export const getAppOrigin = (): string => {
  if (process.env.REACT_APP_FRONTEND_URI_WEB) {
    try {
      return new URL(process.env.REACT_APP_FRONTEND_URI_WEB).origin;
    } catch {
      // fall through
    }
  }
  return window.location.origin;
};

export const getTermsConditionsUrl = (): string => `${getAppOrigin()}/terms-conditions`;

export const getPrivacyPolicyUrl = (): string => `${getAppOrigin()}/privacy-policy`;

export const getContactUrl = (): string => `${getAppOrigin()}/contact`;
